<script lang="ts">
    import { background, poster } from "../assets/videos/index.js";
</script>


    <section class="relative -mb-32 h-screen w-full" style="height: 100svh;">
        <video
            class="absolute top-0 right-0 bottom-0 left-0 z-10 h-full w-full object-cover"
            autoplay
            loop
            muted
            {poster}
        >
            <source src={background} type="video/mp4" />
        </video>
    </section>

